import CorsiCard from "../components/corsi/CorsiCard";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mapBgoRoma, mapSalionze } from "../data/mapLinks";

// import f1 from "../assets/foto/corsi_1.jpg";
import f2 from "../assets/foto/corsi_2.jpg";
// import f3 from "../assets/foto/corsi_3.jpg";
import f4 from "../assets/foto/corsi_4.jpg";

function Corsi() {
  const { t } = useTranslation();

  return (
    <div className="corsi-section">
      <div className="base-text-container text-center">
        <h2 className="base-title">{t("corsi.title")}</h2>
      </div>

      {/* 1 */}
      <div className="md:grid md:grid-cols-2 gap-8 items-center">
        <div className="order-1 md:order-1 col-span-2">
          <div className="corsi-detail-text">
            <p className="base-subtitle">{t("corsi.subtitles.whatIs")}</p>
            <p className="mb-4">{t("corsi.texts.whatIs")}</p>
          </div>
        </div>
        <div className="order-2 md:order-2">
          <div className="corsi-detail-text">
            <p className="base-subtitle">
              {t("corsi.subtitles.practicalInfo")}
            </p>
            <p className="mb-4">{t("corsi.texts.practicalInfo")}</p>
            <p className="base-subtitle mb-4">{t("corsi.subtitles.ourGyms")}</p>
            <ul className="list-disc pl-6">
              <li key="vr" className="font-bold">
                Verona
              </li>
              <ul className="pl-6">
                <li key="vr">{t("corsi.detail.verona.days")}</li>
              </ul>
              <li key="sa" className="font-bold">
                Salionze
              </li>
              <ul className="pl-6">
                <li key="vr">{t("corsi.detail.salionze.days")}</li>
              </ul>
            </ul>
          </div>
        </div>

        <div className="order-3 md:order-3">
          <div className="ricostruzione-detail-grid">
            <CorsiCard
              city="Verona"
              days={t("corsi.detail.verona.days")}
              place={t("corsi.detail.verona.place")}
              mapLink={mapBgoRoma}
            />
            <CorsiCard
              city="Salionze"
              days={t("corsi.detail.salionze.days")}
              place={t("corsi.detail.salionze.place")}
              mapLink={mapSalionze}
            />
          </div>
        </div>
        <div className="order-4 col-span-2">
          <div className="corsi-detail-text order-5">
            <p className="base-subtitle">
              {t("corsi.subtitles.beginInfoTitle")}
            </p>

            {t("corsi.texts.beginInfo", { returnObjects: true }).map(
              (text, index) => (
                <p key={index} className="mb-4">
                  {text}
                </p>
              ),
            )}
          </div>
        </div>
        <div className="order-6 md:order-5">
          <div className="corsi-detail-grid ">
            <img
              className="corsi-detail-grid-img"
              src={f2}
              alt="foto-scherma"
            />
          </div>
        </div>
        <div className="order-5 md:order-6">
          <div className="corsi-detail-text ">
            <p className="base-subtitle">{t("corsi.subtitles.ourMethod")}</p>
            <p className="mb-4">{t("corsi.texts.ourMethod")}</p>
          </div>
        </div>
        <div className="order-7 md:order-7">
          <div className="corsi-detail-text">
            <p className="base-subtitle">{t("corsi.subtitles.wannaTry")}</p>
            <p className="mb-4">{t("corsi.texts.wannaTry")}</p>
          </div>
          <div className="base-subtitle order-9 md:order-9 col-span-2 text-center">
            {t("corsi.texts.CTA")}
            <Link to="/contatti" className="base-link font-bold">
              {t("header.contatti")}
            </Link>
          </div>
        </div>
        <div className="order-8 md:order-8">
          <div className="corsi-detail-grid ">
            <img
              className="corsi-detail-grid-img"
              src={f4}
              alt="foto-scherma"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Corsi;
